<template>
  <div class="about">
    <h1>This is an dashboard page</h1>
  </div>
</template>
